import { ChainId } from 'bzx-common/src/config/appConfig'
import React from 'react'
import { NavLink } from 'react-router-dom'
import ExternalLink from 'shared-components/ExternalLink'
import { Icon } from 'ui-framework'
import { linksMore } from './headerConfig'
import HeaderMoreDropdown from './HeaderMoreDropdown'

interface IHeaderMenuItemProps {
  title: string
  link: string
  icon: string
  external: boolean
}

export interface IHeaderMenuProps {
  items: IHeaderMenuItemProps[]
  onMenuToggle?: () => void
  chainId?: ChainId
  isMobileMedia: boolean
}

export default function HeaderMenu({ items, onMenuToggle, isMobileMedia }: IHeaderMenuProps) {
  if (isMobileMedia) {
    return (
      <div className="header-menu">
        {items.map((item) => (
          <NavLink key={item.link} to={item.link} onClick={onMenuToggle} className="btn btn--menu">
            <Icon
              name={item.icon}
              bgPadding={2}
              size={30}
              color="var(--color-txt-muted)"
              className="margin-right-1 flex-no-shrink"
            />
            <span>{item.title}</span>
          </NavLink>
        ))}

        <div className="margin-top-1">
          <div className="flex-between width-100p padded-15 bg-alternative">
            <div className="header-menu__item-link flex-center">More</div>
          </div>

          <div className="flex-col header-menu--more-dropdown padded-top-05">
            {linksMore.map((item) => {
              return item.external ? (
                <ExternalLink
                  key={item.title}
                  href={item.link}
                  className="btn btn--menu"
                  onClick={item.onClick}>
                  <Icon className="margin-right-1" name={item.icon} size={20} />
                  <span>{item.title}</span>
                </ExternalLink>
              ) : (
                <NavLink
                  key={item.title}
                  to={item.link}
                  className="btn btn--menu"
                  onClick={onMenuToggle}>
                  <Icon className="margin-right-1" name={item.icon} size={20} />
                  <span>{item.title}</span>
                </NavLink>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="header-menu">
      {items.map((item) => {
        return (
          <div className="header-menu__item" key={item.link}>
            {item.external ? (
              <ExternalLink href={item.link} className="header-menu__item-link">
                <span>{item.title}</span>
              </ExternalLink>
            ) : item.title === 'Dashboard' ? (
              <NavLink
                to="/dashboard"
                aria-label="Dashboard"
                className="header-menu__item-link"
                activeClassName="header-menu__item-link--active">
                <Icon name="Dashboard" size={24} />
              </NavLink>
            ) : (
              <NavLink
                to={item.link}
                className="header-menu__item-link"
                activeClassName="header-menu__item-link--active">
                <span>{item.title}</span>
              </NavLink>
            )}
          </div>
        )
      })}
      <div data-tip data-for="menu-more" data-event="click focus" className="header-menu__item">
        <div className="header-menu__item-link flex-center">More</div>
        <Icon className="margin-left-05" name="Arrow-drop-down" height={6} width={12} />
      </div>
      <HeaderMoreDropdown />
    </div>
  )
}
